import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CommonI18TableRowColumnInput from './CommonI18TableRowColumnInput';
import TableRow from 'material-ui/Table/TableRow';
import TableRowColumn from 'material-ui/Table/TableRowColumn';

const tableRowColumnTitleStyle = {
    width: 220,
};

function CommonI18TableRow({ id, defaultLanguage = 'en', statDefault = ' ', ...otherProps }) {
    const tableProps = { ...otherProps };
    Reflect.deleteProperty(tableProps, 'dispatch');

    return (
        <TableRow {...tableProps}>
            <TableRowColumn style={tableRowColumnTitleStyle}>{id}</TableRowColumn>
            <TableRowColumn>{statDefault}</TableRowColumn>
            <TableRowColumn>
                <CommonI18TableRowColumnInput lang={defaultLanguage} label={id} />
            </TableRowColumn>
            <TableRowColumn>
                <CommonI18TableRowColumnInput lang="secondary" label={id} />
            </TableRowColumn>
        </TableRow>
    );
}

CommonI18TableRow.propTypes = {
    id: PropTypes.string.isRequired,
    // From connect
    statDefault: PropTypes.string,
    defaultLanguage: PropTypes.string.isRequired,
};

export default connect(({ commonI18Dashboard: { defaultLanguage, statsDefault } }, { id }) => ({
    defaultLanguage,
    statDefault: statsDefault[id],
}))(CommonI18TableRow);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/CommonI18TableRow.js
 **/